import { Component, OnInit } from "@angular/core";
import { MenuItem } from "primeng/api";
import { AppMainComponent } from "src/app/app.main.component";
import { AuthService } from "src/app/core/endpoints/auth.service";
import { AdminService } from "src/app/core/endpoints/admin.service";
import { ToastService } from "src/app/core/services/toast.service";

import { Observable, timer, map, shareReplay } from "rxjs";
import { GeolocationService } from "@ng-web-apis/geolocation";
import { HttpClient } from "@angular/common/http";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { ApiService } from "src/app/core/services/api.service";
@Component({
	selector: "app-topbar",
	templateUrl: "./app.topbar.component.html",
})
export class AppTopBarComponent implements OnInit {
	items: MenuItem[];
	confirmDeleteDialog:boolean = false;

	constructor(
		public appMain: AppMainComponent,
		public auth: AuthenticationService,
		private toast: ToastService,
		private apiService: ApiService
	) {}

	ngOnInit(): void {}

	private _time$: Observable<Date> = timer(0, 1000).pipe(
		map((tick) => new Date()),
		shareReplay(1)
	);

	get dateToday() {
		return this._time$;
	}

	getUser() {
		return AuthService.isLogged() ? AuthService.getDataUser() : null;
	}
	
	deleteAccount() {
		this.confirmDeleteDialog = true;
	}
	
	deleteAccountConfirm() {
		this.apiService
			.deleteEntity("deleteUser", this.getUser().id)
			.subscribe({
				next: (result) => {
					this.logout();
				},
				error: (err) => {
				},
				complete: () => {
				},
			});

		this.confirmDeleteDialog = false;
	}
	deleteAccountCancel() {
		this.confirmDeleteDialog = false;
	}

	logout() {
		this.apiService.logout();
	}
}
